import React from 'react';
import { Form } from 'react-final-form';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import { nl2 } from 'util/filters';
import Button from 'components/common/Button';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import i18n from 'i18n';

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      values: undefined
    };
  }

  open = values => {
    this.setState({
      visible: true,
      values
    });
  };

  close = async () => {
    this.setState({
      visible: false
    });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    this.setState({
      visible: false
    });
    onSubmit && onSubmit(this.state.values);
  };

  render() {
    const { className, title, message } = this.props;

    if (!this.state.visible) {
      return null;
    }

    return (
      <Form
        onSubmit={() => this.handleSubmit()}
        close={() => this.close()}
        render={() => (
          <div className={className}>
            <div className="confirm-dialog">
              <div className="confirm-dialog-body">
                {title && <h4>{nl2(title)}</h4>}
                <p>{nl2(message)}</p>
              </div>
              <footer>
                <button
                  type="button"
                  className="cancel"
                  onClick={() => this.close()}
                >
                  {i18n.t('common:cancel')}
                </button>
                <Button
                  type="button"
                  buttonType="B"
                  className="confirm"
                  onClick={() => this.handleSubmit()}
                >
                  {i18n.t('common:ok')}
                </Button>
              </footer>
            </div>
          </div>
        )}
      />
    );
  }
}

const commonStyle = css`
  ${FontStyles.text8}
  position: fixed;
  display: block;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .confirm-dialog {
    background-color: ${Colors.white1};
    border: 1px solid ${Colors.black1};
    box-shadow: 0px 0px 14px -2px #787878;

    .confirm-dialog-body {
      white-space: pre-line;

      h4 {
        margin: 0;
      }

      p {
        margin: 0;
      }
    }

    footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      button {
        cursor: pointer;
        margin: 0;
      }

      .confirm {
        width: 64px;
        font-weight: bold;
      }

      .cancel {
        border: none;
        appearance: none;
        outline: none;
        background-color: transparent;
        color: ${Colors.orange1};

        &:active,
        &:hover {
          color: ${Colors.orange3};
          cursor: pointer;
        }
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .confirm-dialog {
    width: 506px;
    padding: 26px 32px 32px;
    border-radius: 16px;

    .confirm-dialog-body {
      ${FontStyles.text8};

      h4 {
        ${FontStyles.text5};

        margin-bottom: 7px;
      }
    }

    footer {
      margin-top: 37px;

      button {
        width: 96px;
        height: 36px;
        margin: 0;
      }

      .cancel {
        margin-right: 17px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .confirm-dialog {
    width: calc(100% - 64px);
    max-width: 423px;
    padding: 27px 24px 32px;
    border-radius: 8px;

    .confirm-dialog-body {
      ${FontStyles.text6};

      h4 {
        ${FontStyles.text2};

        margin-bottom: 6px;
      }
    }

    footer {
      margin-top: 36px;

      button {
        width: 100px;
        height: 36px;
      }

      .cancel {
        margin-right: 8px;
      }
    }
  }
`;

export default applyStyles(ConfirmDialog)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/ConfirmDialog.js